export default __webpack_public_path__ + "static/media/2022-aurelie.650035a1.jpg";